import type { Category } from "../Category.js";
import type { Locale } from "../Locale.js";
import { productsPathMap } from "./productsPathMap.js";

export function getProductsCategoryPath({ urlSlug }: Pick<Category, "urlSlug">, locale: Locale): string {
	return `${productsPathMap[locale]}/${urlSlug}`;
}
